<template>
  <v-container
    fluid
    style="min-height: inherit"
    class="d-flex flex-row pa-0 h-100"
    :class="{ 'max-width-1500': type != 'Admin' }"
  >
    <agency-left-section class="hidden-sm-and-down" v-if="type == 'Agency' && token" />
    <unauth-left-section
      class="hidden-sm-and-down"
      v-if="!token"
    />
    <company-left-section class="hidden-sm-and-down" v-if="type == 'Company' && token" />
    <volunteer-left-section
      class="hidden-sm-and-down"
      v-else-if="type == 'Volunteer' && token"
    />
    <admin-home-side-menu v-else-if="type == 'Admin'" />
    <router-view v-if="type == 'Agency' || type == 'Volunteer' || type == 'Admin'"/>
    <not-found v-else />
    <agency-right-section class="hidden-md-and-down" v-if="type == 'Agency' && token" />
    <unauth-right-section
      class="hidden-md-and-down"
      v-if="!token"
    />
    <volunteer-right-section
      class="hidden-md-and-down"
      v-else-if="type == 'Volunteer' && token"
    />
    <admin-right-section
      class="hidden-sm-and-down"
      v-else-if="type == 'Admin'"
    />

    <v-snackbar v-model="snackbar">
      {{ errorMessage }}
    </v-snackbar>
  </v-container>
</template>
<script>
import { mapActions, mapState } from "vuex";
import AdminRightSection from "../../admin/AdminRightSection.vue";
import VolunteerLeftSection from "../../volunteer/VolunteerLeftSection.vue";
import VolunteerRightSection from "../../volunteer/VolunteerRightSection.vue";
import AgencyLeftSection from "../AgencyLeftSection.vue";
import AgencyRightSection from "../AgencyRightSection.vue";
import AdminHomeSideMenu from "../../admin/home/AdminHomeSideMenu.vue";
import CompanyLeftSection from "../../company/CompanyLeftSection.vue";
import UnauthLeftSection from '../../agency/UnauthLefSection.vue';
import UnauthRightSection from '../../agency/UnauthRightSection.vue';
import NotFound from "../../NotFound.vue";
export default {
  components: {
    AgencyLeftSection,
    AgencyRightSection,
    VolunteerLeftSection,
    VolunteerRightSection,
    AdminRightSection,
    AdminHomeSideMenu,
    CompanyLeftSection,
    UnauthLeftSection,
    UnauthRightSection,
    NotFound
  },
  data() {
    return {
      loading: false,
      errorMessage: null,
      snackbar: false,
      token: null,
      Iftoken: false
    };
  },
  methods: {
    ...mapActions("event", {
      fetchAllEvents: "fetchAllEvents"
    }),
    showErrorMessage(message) {
      this.errorMessage = message;
      this.snackbar = true;
    },
        fetchToken() {
      this.token = localStorage.getItem("user-token");
      if (this.token) {
        //console.log("Token found:", this.token);
        this.Iftoken = true;
      } else {
        this.Iftoken = false;
        console.log("Token not found in local storage.");
      }
    },
  },
  computed: {
    ...mapState("auth", {
      type: "type"
    })
  },
    created() {
    this.fetchToken();
  },
};
</script>
<style scoped></style>
